export default __webpack_public_path__ + "static/article-saving-for-a-baby-4b8226acb9b5c87e9a5b4b1ef78f0415.jpg";